export const amazonLink = "https://fronteirafinal.s3.sa-east-1.amazonaws.com/";
